import type { CopyShape } from "@tami/core/intl";

import type { CALCULATOR_SCRIPT_COPY_PT_BR } from "../calculator-script.copy";
import { formatCurrency } from "@tami/core/intl";

export const CALCULATOR_SCRIPT_COPY_ES_ES: CopyShape<typeof CALCULATOR_SCRIPT_COPY_PT_BR> = {
  calcIntro: {
    narrative:
      "Calculadora de publis: ponle precio a tus entregas con criterio, guarda estrategias y reutilízalas cuando llegue la propuesta.",
  },
  calcToolbar: {
    narrative:
      "Busca cálculos guardados, oculta los importes en pantalla y abre uno nuevo cuando quieras probar otra combinación de entregables.",
    callout: "Busca por nombre, controla la visibilidad de los importes y crea un cálculo nuevo en un clic.",
  },
  calcOverview: {
    narrative: "Cada estrategia se guarda con título, inversión sugerida y fecha de la última actualización.",
  },
  calcCards: {
    narrative:
      "Mira el importe sugerido de cada publi de un vistazo — listo para enviárselo a la marca o convertirlo en campaña.",
    callout: "Tarjetas con la inversión, una etiqueta de importe sugerido y el historial de cambios.",
  },
  calcCardValue: {
    narrative: "La inversión total tiene en cuenta entregables, tiempo de producción y margen — sin hojas de cálculo a mano.",
    callout: "Importe sugerido calculado a partir de los parámetros de tu estrategia de publi.",
  },
  calcNew: {
    narrative: "Nuevo cálculo abre el simulador completo: redes, formatos, plazos y margen — todo configurable.",
    callout: "+ Nuevo cálculo — monta una propuesta desde cero o duplica una que ya tengas.",
  },
  calcModalOpen: {
    narrative:
      "La calculadora se abre en un modal: rellena perfil, entregables y extras mientras el importe se actualiza en directo.",
    callout: "Nuevo cálculo de precio — simulador completo sin salir de la lista de cálculos.",
  },
  calcModalTitle: {
    narrative: "Ponle nombre al cálculo — collab, pack mensual o propuesta suelta, fácil de encontrar después.",
    callout: "Ponle nombre a la estrategia — p. ej.: Collab moda verano.",
  },
  calcModalProfile: {
    narrative: "El nicho y los años de carrera entran en el cálculo — Tãmi ajusta la franja de precio a tu perfil.",
    callout: "Perfil del creator: el nicho y la experiencia influyen en el mínimo, la media y el máximo.",
  },
  calcModalDeliverables: {
    narrative: "Indica redes, seguidores y cuántos reels o stories entran — el alcance define el importe base.",
    callout: "Entregables por red — reels, stories y otros formatos configurables.",
  },
  calcModalExtras: {
    narrative: "La exclusividad, la promoción pagada y los costes extra suben o bajan la propuesta al momento.",
    callout: "Extras como la exclusividad entran en el cálculo automáticamente.",
  },
  calcModalResult: {
    narrative: "El mínimo, la media y el máximo aparecen arriba — mira la franja sugerida antes de enviársela a la marca.",
    get callout(): string {
      return `${formatCurrency(2709)} de media — la franja completa sigue a la vista mientras ajustas los campos.`;
    },
  },
  calcModalSave: {
    narrative: "Guarda el cálculo y reutilízalo cuando llegue la propuesta — o conviértelo directamente en campaña.",
    callout: "Guardar cálculo — cópialo, expórtalo o guárdalo en tu biblioteca de cálculos.",
  },
};
